import React, { Component, lazy, Suspense } from 'react'
import { withRouter } from 'react-router-dom'

import Icon from '../utility/Icon'

const BurgerMenu = lazy(() => import('./BurgerMenu'))

class BurgerButton extends Component {
  constructor(props) {
    super(props)

    this.state = {
      visible: false
    }

    this.onClick = this.onClick.bind(this)
  }

  onClick() {
    this.setState({
      visible: !this.state.visible
    })
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.visible &&
      prevProps.location.key !== this.props.location.key
    ) {
      this.onClick()
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.state.visible && (
          <Suspense fallback="">
            {<BurgerMenu visible={this.state.visible} onClose={this.onClick} />}
          </Suspense>
        )}
        <button aria-label="Open Menu" onClick={this.onClick}>
          <Icon icon="bars" />
        </button>
      </React.Fragment>
    )
  }
}

export default withRouter(BurgerButton)
